/* @flow */

export const NETGEM_API_V8_AUTHENT_REALM_NETGEM: 'netgem' = 'netgem';
export const NETGEM_API_V8_AUTHENT_REALM_VIDEOFUTUR: 'videofutur' = 'videofutur';
export type NETGEM_API_V8_AUTHENT_REALM = typeof NETGEM_API_V8_AUTHENT_REALM_NETGEM | typeof NETGEM_API_V8_AUTHENT_REALM_VIDEOFUTUR;
